import { HttpPromise } from "@shared/svelte/Modules/ApiService";
import type { Category, Container, ProductType } from "@shared/types/ProductLine";

type ProductTypesParams = {
  filtered?: boolean;
  smart_filter_distributor?: boolean;
  quick_order_list_ids?: number[];
};

export const getProductTypes = async (
  params: ProductTypesParams = null,
): Promise<{
  categories: Category[];
  containers: Container[];
  types: ProductType[];
}> => {
  try {
    return await HttpPromise({
      data: params,
      method: "GET",
      url: "/api/retailer/product_types",
    });
  } catch (e) {
    return {
      categories: [],
      containers: [],
      types: [],
    };
  }
};
